import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useInventoryStore } from '../../stores/useInventoryStore'
import { usePlayerStore } from '../../stores/usePlayerStore'
import { Card } from '../ui/Card'
import { Button } from '../ui/Button'

export const Inventory: React.FC = () => {
  const { t } = useTranslation()
  const { items, isLoading, loadInventory } = useInventoryStore()
  const { player } = usePlayerStore()

  useEffect(() => {
    if (player?.id) {
      loadInventory(player.id)
    }
  }, [player?.id])

  if (isLoading) {
    return (
      <Card title={`📦 ${t('inventory.title')}`} subtitle={t('common.loading')}>
        <div className="flex justify-center p-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      </Card>
    )
  }

  return (
    <Card title={`📦 ${t('inventory.title')}`} subtitle={t('inventory.subtitle')}>
      <div className="space-y-4">
        {items.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((item) => (
              <div
                key={item.product_id}
                className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
              >
                <div className="flex justify-between items-start mb-2">
                  <h3 className="font-semibold text-gray-700">
                    {item.product?.name || t('inventory.unknownProduct')}
                  </h3>
                  <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">
                    {t('inventory.quality')}: {item.quality}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-3">
                  <span className="text-gray-600">{t('inventory.quantity')}: {item.quantity}</span>
                  <span className="text-green-600 font-medium">
                    {((item.product?.base_price || 0) * item.quantity).toLocaleString()} 💰
                  </span>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" variant="primary">
                    {t('inventory.sell')}
                  </Button>
                  <Button size="sm" variant="secondary">
                    {t('inventory.details')}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">📦</span>
            </div>
            <h3 className="text-lg font-medium text-gray-700 mb-2">
              {t('inventory.emptyInventory')}
            </h3>
            <p className="text-gray-500 mb-4">
              {t('inventory.emptyInventoryMessage')}
            </p>
            <Button variant="primary">
              {t('inventory.startProduction')}
            </Button>
          </div>
        )}
      </div>
    </Card>
  )
}
